import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../common/select';
import { t } from '../../../../../modules/infra/i18n';

const AcquisitionChannel = ({ options, className, leadAutoAssigned }) => (
  <div className={className}>
    <div className="c-label-new">{t('customers:acquisition_channel.label')}</div>
    <Select
      className="c-select"
      name="leadId"
      disabled={leadAutoAssigned}
      parse={val => val || null}
      options={options}
      empty={t('customers:acquisition_channel.not_provided')}
    />
  </div>
);
AcquisitionChannel.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  className: PropTypes.string,
  leadAutoAssigned: PropTypes.bool,
};
AcquisitionChannel.defaultProps = {
  options: [],
  className: '',
  leadAutoAssigned: false,
};

export default AcquisitionChannel;
